"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormVersionTranslation = void 0;
var FormVersionTranslation = /** @class */ (function () {
    function FormVersionTranslation() {
        this.localeCode = '';
        this.localeName = '';
        this.isDefault = false;
        this.isEnabled = true;
        this.updatedAt = new Date();
        this.translations = {};
    }
    return FormVersionTranslation;
}());
exports.FormVersionTranslation = FormVersionTranslation;
